//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WarrantyFormDialog from './UtilComponents/WarrantyFormDialog.vue'
import InsuranceFormDialog from './UtilComponents/InsuranceFormDialog.vue'
import { toCurrency } from '@/helpers/currency'
import { removeUndefinedProps } from '~/helpers/objectHelper'
import TabFooter from '~/components/FinanceApplication/Tabs/TabFooter'
import { changeRoute } from '~/helpers/changeRoute'
import {
  LABEL_FOR_WARRANTY,
  DOCUMENT_EDIT_LINK,
  LABEL_FOR_ADD_WARRANTY,
  LABEL_FOR_PROVIDER,
  LABEL_NOT_AVAILABLE,
  LABEL_FOR_PRODUCT,
  LABEL_FOR_WHOLESALE,
  LABEL_FOR_RETAIL,
  LABEL_FOR_COMMISSION,
  LABEL_FOR_INSURANCE,
  LABEL_FOR_ADD_INSURANCE,
  LABEL_FOR_PREMIUM,
  LABEL_FOR_POLICY,
  LABEL_NEXT,
  SETTLEMENT_MENU_LOAN_DETAILS_KEY,
  FINANCE_APPLICATION_TAB_NOTES_KEY,
} from '~/constants/applications'
import {
  LABEL_FOR_FREQUENCY,
  USER_SESSION_DATA_KEY,
  USER_TYPE_AGENT,
  USER_TYPE_SETTLEMENT,
  LABEL_ANNUALLY_OPTION_VALUE,
  LABEL_ANNUALLY_OPTION_LABEL,
  APPLICATION_STATUS_SUBMITTED_FOR_SETTLEMENT,
  APPLICATION_STATUS_SETTLED,
} from '@/constants'
import { validateUserRoles } from '~/helpers/user'
export default {
  components: {
    WarrantyFormDialog,
    InsuranceFormDialog,
    TabFooter,
  },
  props: {
    primaryData: {
      type: Object,
      default: () => ({}),
    },
    secondaryData: {
      type: Array,
      default: () => [],
    },
    sharedData: {
      type: Object,
      default: () => ({}),
    },
    isApplicationSettled: {
      type: Boolean,
      default: false,
    },
    isFromSettlementTab: {
      type: Boolean,
      default: true,
    },
    isCommercial: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      DOCUMENT_EDIT_LINK,
      LABEL_FOR_WARRANTY,
      LABEL_FOR_ADD_WARRANTY,
      LABEL_FOR_PROVIDER,
      LABEL_NOT_AVAILABLE,
      LABEL_FOR_PRODUCT,
      LABEL_FOR_WHOLESALE,
      LABEL_FOR_RETAIL,
      LABEL_FOR_COMMISSION,
      LABEL_FOR_INSURANCE,
      LABEL_FOR_POLICY,
      USER_SESSION_DATA_KEY,
      USER_TYPE_AGENT,
      USER_TYPE_SETTLEMENT,
      LABEL_FOR_ADD_INSURANCE,
      LABEL_FOR_PREMIUM,
      LABEL_FOR_FREQUENCY,
      LABEL_NEXT,
      LABEL_ANNUALLY_OPTION_VALUE,
      LABEL_ANNUALLY_OPTION_LABEL,
      SETTLEMENT_MENU_LOAN_DETAILS_KEY,
      FINANCE_APPLICATION_TAB_NOTES_KEY,
      APPLICATION_STATUS_SUBMITTED_FOR_SETTLEMENT,
      APPLICATION_STATUS_SETTLED,
      loanData: {},
      isDialogLoading: false,
      WarrantyFormDialog: false,
      InsuranceFormDialog: false,
    }
  },
  async mounted() {
    this.$nuxt.$on('closeRequestWarrantyDialog', () => {
      this.WarrantyFormDialog = false
    })
    this.$nuxt.$on('closeRequestInsuranceDialog', () => {
      this.InsuranceFormDialog = false
    })
    this.$nuxt.$on('close-loader', () => {
      this.getIsDialogLoading = false
    })
  },
  beforeDestroy() {
    this.$nuxt.$off('closeRequestWarrantyDialog')
    this.$nuxt.$off('closeRequestInsuranceDialog')
    this.$nuxt.$off('close-loader')
  },
  computed: {
    loanDetailsForm() {
      return this.setInitialData()
    },
    isSettled() {
      return this.loanData.appData.status === APPLICATION_STATUS_SETTLED
    },
    disableInsuranceAndWarranty() {
      const userRoles = this.$auth.$storage.getUniversal(
        USER_SESSION_DATA_KEY
      )?.systemRoleTypes
      return (
        validateUserRoles(userRoles, [USER_TYPE_AGENT, USER_TYPE_SETTLEMENT]) &&
        this.isSettled
      )
    },
    getInsuranceFrquency() {
      const frequency =
        this.loanData.appData?.loanDetails?.settlement?.insurance?.frequency ||
        ''
      return frequency
        ? frequency === LABEL_ANNUALLY_OPTION_VALUE
          ? LABEL_ANNUALLY_OPTION_LABEL
          : frequency
        : LABEL_NOT_AVAILABLE
    },
  },
  methods: {
    setInitialData() {
      this.loanData = {
        appData: removeUndefinedProps(this.sharedData),
      }

      if (
        this.loanData.appData.loanDetails.settlement &&
        !this.loanData.appData.loanDetails.settlement.warranty
      ) {
        this.loanData.appData.loanDetails.settlement.warranty = {
          provider: '',
          product: '',
          wholesale: '',
          retail: '',
          commission: '',
        }
      }

      if (
        this.loanData.appData.loanDetails.settlement &&
        !this.loanData.appData.loanDetails.settlement.insurance
      ) {
        this.loanData.appData.loanDetails.settlement.insurance = {
          provider: '',
          product: '',
          wholesale: '',
          retail: '',
          commission: '',
        }
      }
      return true
    },
    numberWithCommas(x) {
      return toCurrency(x)
    },
    openWarrantyForm() {
      this.WarrantyFormDialog = true
    },
    openInsuranceForm() {
      this.InsuranceFormDialog = true
    },
    async sectionRedirect(subTab) {
      this.$emit('sectionRedirect', subTab)
    },
    async gotoNext() {
      const { id, applicationId } = this.$route.params
      await changeRoute({
        route: this.$route,
        router: this.$router,
        path: `/finance/applications/${id}/${applicationId}`,
        query: {
          maintab: FINANCE_APPLICATION_TAB_NOTES_KEY,
        },
      })
      this.$nuxt.$emit('updateComponent', FINANCE_APPLICATION_TAB_NOTES_KEY)
    },
  },
}
